import { Content } from "../../types/content.interface";

export const awardsData: Content[] = [
  {
    enSubtitle: "Personal",
    krSubtitle: "Personal",
    isDisplay: true,
    details: [
      {
        enText: "2020 Sogang Programming Contest - ",
        krText: "2020 서강대학교 프로그래밍 대회 SPC - ",
        enEndBold: "A Bronze prize",
        krEndBold: "동상",
        isDisplay: true,
      },
    ],
  },
  {
    enSubtitle: "Team",
    krSubtitle: "Team",
    isDisplay: true,
    details: [
      {
        enText: "2025 Amazon Q Developer Hackathon - ",
        krText: "2025 Amazon Q Developer Hackathon - ",
        enEndBold: "The top prize",
        krEndBold: "대상",
        linkText: "link",
        linkUrl: "https://github.com/americano212/amazon-q-hackathon",
        isDisplay: true,
      },
      {
        enText: "2025 Blaybus Mobile App Hackathon - ",
        krText: "2025 Blaybus 실전 앱 개발 경진대회 - ",
        enEndBold: "Excellence Award",
        krEndBold: "우수상",
        linkText: "link",
        linkUrl: "https://github.com/americano212/dohands-hackathon-backend",
        isDisplay: true,
      },
      {
        enText: "2022 Winter SUAPC (Algorithm Contest) - ",
        krText: "2022 Winter SUAPC (알고리즘 대회) - ",
        enEndBold: "9th",
        krEndBold: "9등",
        isDisplay: false,
      },
      {
        enText: "2021 Sogang University Artech Hackathon - ",
        krText: "2021 서강대학교 아텍 해커톤 - ",
        enEndBold: "The top prize",
        krEndBold: "우승",
        isDisplay: true,
      },
      {
        enText: "2021 Summer SUAPC (Algorithm Contest) - ",
        krText: "2021 Summer SUAPC (알고리즘 대회) - ",
        enEndBold: "19th",
        krEndBold: "19등",
        isDisplay: false,
      },
      {
        enText: "2021 ICPC Asia Seoul Preliminary Contest - ",
        krText: "2021 ICPC 서울 지역 예선 - ",
        enEndBold: "86th",
        krEndBold: "86등",
        isDisplay: false,
      },
      {
        enText: "2020 The 4th Government Innovation Proposal Hackathon - ",
        krText: "2020 제4회 정부혁신제안 끝장개발대회(해커톤) - ",
        enEndBold: "Popularity Award",
        krEndBold: "인기상",
        isDisplay: true,
      },
      {
        enText: "2020 IEEEXtreme 14.0 (Algorithm Contest) - ",
        krText: "2020 IEEEXtreme 14.0 (알고리즘 대회) - ",
        enEndBold: "Global 396th",
        krEndBold: "전세계 396등",
        isDisplay: false,
      },
    ],
  },
];
